import React, { useContext } from "react";
import { Icon } from "components/SvgIcons";
import GroceryContext from "../GroceryContext";
import { CheckWrap, ItemText, ItemName } from "../styled";
import { CustomIngredientItemContainer, CustomItemLeft, CustomItemRight } from "./styled";

const CustomIngredientItem = ({ item }) => {
  const { toggleCustomItem, removeCustomItem, editCustomItem } = useContext(GroceryContext);
  const { name, id } = item;

  return (
    <CustomIngredientItemContainer onClick={() => toggleCustomItem(item)}>
      <CustomItemLeft>
        <CheckWrap>
          <Icon icon="check" />
        </CheckWrap>
        <ItemText>
          <ItemName>{name}</ItemName>
        </ItemText>
      </CustomItemLeft>

      <CustomItemRight>
        <Icon
          icon="edit"
          onClick={(e) => {
            e.stopPropagation();
            editCustomItem(id);
          }}
        />
        <Icon
          icon="delete"
          onClick={(e) => {
            e.stopPropagation();
            removeCustomItem(id);
          }}
        />
      </CustomItemRight>
    </CustomIngredientItemContainer>
  );
};

export default CustomIngredientItem;
